import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { GalleryPreview } from './gallery-preview'
import { DocumentsGalleryProps } from './documents-gallery.types'
import { Translation } from './translation'
import { GalleryThumbnails } from './gallery-thumbnails'

const Container = styled.div`
  display: flex;
  background: white;
  margin-left: auto;
  flex-direction: column;
  width: 100%;
`

export { isPdfDocument, getDocumentKind } from './document-kind'

export function DocumentsGallery({
  files,
  withPreview,
  previewUrl,
  translationContentTitle,
  disableWheelZoom = false,
  onSelectedFileChange,
  documentPreviewLabels,
}: Readonly<DocumentsGalleryProps>) {
  const [isTranslationModalOpen, setIsTranslationModalOpen] = useState(false)
  const [selectedFileUrl, setSelectedFileUrl] = useState(
    withPreview ? files?.[0]?.url : ''
  )

  const onThumbnailClick = (src: string) => {
    if (withPreview) {
      setSelectedFileUrl(src)
    } else {
      window.open(src, '_blank')
    }
  }

  useEffect(() => {
    onSelectedFileChange?.(selectedFileUrl)
  }, [onSelectedFileChange, selectedFileUrl])

  if (!files?.length) return null

  const hasTranslation = files.some(
    (file) => file.url === selectedFileUrl && file.translation
  )

  const showThumbnails = withPreview ? files?.length > 1 : true

  return (
    <Container data-testid="documents-gallery">
      {showThumbnails && (
        <GalleryThumbnails
          files={files}
          selectedFileUrl={selectedFileUrl}
          onThumbnailClick={onThumbnailClick}
        />
      )}
      {hasTranslation && isTranslationModalOpen && (
        <Translation
          onClose={() => setIsTranslationModalOpen(false)}
          files={files}
          url={selectedFileUrl}
          translationContentTitle={translationContentTitle}
        />
      )}

      {withPreview && (
        <GalleryPreview
          url={selectedFileUrl}
          previewUrl={previewUrl}
          onShowTranslation={
            hasTranslation ? () => setIsTranslationModalOpen(true) : undefined
          }
          wheelDisabled={disableWheelZoom}
          documentPreviewLabels={documentPreviewLabels}
        />
      )}
    </Container>
  )
}
